var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscover18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.93 1.5A6.47 6.47 0 0 0 1.5 8c0 3.6 2.88 6.5 6.43 6.5A6.47 6.47 0 0 0 14.37 8c0-1.72-.68-3.38-1.89-4.6a6.4 6.4 0 0 0-4.55-1.9Zm8.25 13.29-1.92-1.55a.74.74 0 0 0-1.04 0 .81.81 0 0 0 0 1.14l1.59 1.83c.38.39 1.01.39 1.4 0 .39-.4.39-1.03 0-1.42h-.03ZM8 13A5 5 0 1 0 8 3a5 5 0 0 0 0 10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover18);
export default __webpack_public_path__ + "static/media/discover-18.2ea911ac6845775ee4c857ed94fd7e83.svg";
export { ForwardRef as ReactComponent };